import AppNavbar from "../../Navbar/AppNavbar"
import Footer from "../../Navbar/Footer";
import '../../../assets/css/search.scss'
import '../../../assets/css/viewedContacts.scss'
import { useRef, useState, useEffect } from "react";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useDispatch, useSelector } from "react-redux";
import ViewedContactsTable from "./ViewedContactsTable";
import { getViewedContactsData, loadViewedContactsData } from "../../redux/action";
import { Circles, RotatingLines } from "react-loader-spinner";
import { useLocation } from "react-router-dom";

const ViewedContacts = () => {
    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;
    const sbnID = signInDetails[0]?.sbn_id;
    const role = signInDetails[0]?.role;
    const location = useLocation();
    const listName = location.state?.listName || "Default";

    const listProvider = (
        location.state?.provider ||
        sessionStorage.getItem("list_provider") ||
        null
    );

    useEffect(() => {
        console.log("VIEWED CONTACTS NAV STATE =>", location.state);

        if (location.state?.provider) {
            const p = String(location.state.provider).toLowerCase();
            sessionStorage.setItem("list_provider", p);
            console.log("SET list_provider =>", p);
        }
    }, [location.state]);

    const { getViewedContacts = [] } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);

    const [tableHeight, setTableHeight] = useState(0);

    const [loading, setLoading] = useState(false);
    const rowsPerPage = 20;
    const [page, setPage] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);
    const [selectedRowsData, setSelectedRowsData] = useState([]);
    const [bulkUnlock, setBulkUnlock] = useState(false);
    const [selectFilter, setSelectFilter] = useState({ label: "All Contacts", value: "All" });

    const [downloading, setDownloading] = useState(false);
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;
        if (page === 1) {
            setLoading(true);
            dispatch(getViewedContactsData([]))
        }
        fetchViewedContact(page, selectFilter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchViewedContact = (page, selectFilter) => {
        if (page === 1) {
            setLoading(true);
            dispatch(getViewedContactsData([]))
        }
        dispatch(loadViewedContactsData(signInID, sbnID, listName, role, page, rowsPerPage, setLoading, setLoadingMore, selectFilter));
    }

    const divRef = useRef(null);
    const div1Ref = useRef(null);
    const div2Ref = useRef(null);
    const [height1, setHeight1] = useState(0);
    const [height2, setHeight2] = useState(0);

    useEffect(() => {
        if (div1Ref.current) {
            setHeight1(div1Ref.current.offsetHeight);
        }
        if (div2Ref.current) {
            setHeight2(div2Ref.current.offsetHeight);
        }
    }, []);

    useEffect(() => {
        if (!divRef.current) return;

        const parentHeight = divRef.current.offsetHeight;

        const pixelAdjustment = height1 + height2 + 10;

        const tablePxHeight = parentHeight - pixelAdjustment;

        setTableHeight(tablePxHeight);
    }, [height1, height2]);


    return (
        <div className="page-layout" style={{ position: "relative" }}>
            <AppNavbar />
            <div className="page-content">
                <div className="viewed-contacts-container" ref={divRef} style={{ height: '100%' }}>
                    <div className="viewed-contacts-div">
                        <div className="viewed-contacts-header" ref={div1Ref}>
                            <p>Viewed</p>
                            <div className="viewed-contacts-view-img-div">
                                <h5>Contacts</h5>
                                <i className="fa-regular fa-eye"></i>
                            </div>
                        </div>
                        <ViewedContactsTable
                            page={page}
                            setPage={setPage}
                            rowsPerPage={rowsPerPage}
                            totalDataCount={totalDataCount}
                            loading={loading}
                            fetchViewedContact={fetchViewedContact}
                            loadingMore={loadingMore}
                            setLoadingMore={setLoadingMore}
                            tableHeight={tableHeight}
                            selectedRowsData={selectedRowsData}
                            setSelectedRowsData={setSelectedRowsData}
                            getViewedContacts={getViewedContacts}
                            div2Ref={div2Ref}
                            // handleDownload={handleDownload}
                            setDownloading={setDownloading}
                            signInID={signInID}
                            sbnID={sbnID}
                            role={role}
                            listName={listName}
                            listProvider={listProvider}
                            setBulkUnlock={setBulkUnlock}
                            setSelectFilter={setSelectFilter}
                            selectFilter={selectFilter}
                        />
                    </div>
                </div>
            </div>
            {downloading && (
                <div className="download-overlay">
                    <div className="download-loader-content">
                        <Circles
                            height="30"
                            width="30"
                            color="#007bff"
                            ariaLabel="circles-loading"
                            visible={true}
                        />
                        <span className="ms-2">Downloading, please wait...</span>
                    </div>
                </div>
            )}
            {bulkUnlock && <div className="download-overlay">
                <div className="download-loader-content">
                    <RotatingLines
                        visible={true}
                        height="80"
                        width="80"
                        color="#2e5ec7"
                        strokeWidth="5"
                    />
                    <span className="ms-2">Unlocking, please wait...</span>
                </div>
            </div>}

            <Footer />
        </div>
    )
}

export default ViewedContacts;